import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App.vue';
import router from './router';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import VueApexCharts from 'vue3-apexcharts';
import draggable from 'vuedraggable';
import 'swiper/swiper-bundle.css';
import './registerServiceWorker';
import { createI18n } from 'vue-i18n';
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';


// Import language files for each locale
import enCAD from './locales/en-CAD.json';
import enUS from './locales/en-US.json';
import frCAD from './locales/fr-CAD.json';

Amplify.configure(awsExports);
const pinia = createPinia();

const i18n = createI18n({
  locale: 'en-CAD', 
  messages: {
    'en-CAD': enCAD,
    'en-US': enUS,
    'fr-CAD': frCAD,
  },
});

const app = createApp(App);

app.component('font-awesome-icon', FontAwesomeIcon, FullCalendar,dayGridPlugin)
   .component('apexchart', VueApexCharts)
   .component('draggable', draggable)
   .use(router)
   .use(pinia)
   .use(library)
   .use(i18n)

   .mount('#app');
